import React from 'react';
import { Outlet } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import SellerNavbar from './SellerNavbar';

const SellerLayout = () => (
  <ProtectedRoute allowedRoles={['seller', 'admin']}>
    <div className="min-h-screen bg-gray-50">
      <SellerNavbar />
      <main className="max-w-6xl mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  </ProtectedRoute>
);

export default SellerLayout;
